import { useSelector } from 'react-redux';

import { appMetaSelectors } from '../../../../store/modules/appMeta';

const useWorkspaceParam = (pref = '&') => {
  const workspace = useSelector(appMetaSelectors.selectWorkspace);
  const workspaceParam = workspace === 'team' ? `${pref}workspace=${workspace}` : '';

  return workspaceParam;
};

export default useWorkspaceParam;
